module.exports = __webpack_public_path__ + "img/ico-8-active.0d9f33d0.svg";